<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    xml:space="preserve"
  >
    <defs>
      <!-- Точный глиф лупы одиночной проценки (SingleSearchIcon): ручка + круг +
           внутренняя дуга-блик + насечка. Передняя и задняя лупы используют один
           и тот же глиф — обе идентичны лупе проценки. -->
      <g id="selection-lens">
        <path
          d="M15.3122,13.6513l3.9386,3.9386c0.3323,0.3323,0.3323,0.876,0,1.2082l-0.4356,0.4356c-0.3323,0.3323,-0.876,0.3323,-1.2082,0l-3.9657,-3.9657"
        />
        <circle
          cx="9.0062"
          cy="9"
          r="7.5"
        />
        <path d="M14.5071,8.625c-0.2061,-2.7797,-2.4594,-4.9895,-5.2575,-5.1274" />
        <line
          x1="15.1"
          y1="16.2"
          x2="16.2"
          y2="15.1"
        />
      </g>

      <!-- Вырез силуэта передней лупы (круг с запасом) в глобальных координатах —
           даёт равномерный концентричный зазор там, где задняя лупа уходит за переднюю -->
      <mask id="selection-front-cut">
        <rect
          x="0"
          y="0"
          width="21"
          height="21"
          fill="white"
        />
        <circle
          cx="7.5"
          cy="11"
          r="7.1"
          fill="black"
        />
      </mask>
    </defs>

    <g
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.43"
    >
      <!-- Задняя лупа: та же лупа проценки, смещена вверх-вправо по общей диагонали;
           зазор до передней равномерный, ручка параллельна передней -->
      <use
        href="#selection-lens"
        transform="translate(5.4, 0.5) scale(0.7)"
        mask="url(#selection-front-cut)"
      />
      <!-- Передняя лупа проценки -->
      <use
        href="#selection-lens"
        transform="translate(1.2, 4.7) scale(0.7)"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
